import React from 'react';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import Box from '@amzn/meridian/box';
import Text from '@amzn/meridian/text';
import Tooltip from '@amzn/meridian/tooltip';
import { SummaryStatsRowProps } from '../model';

const SummaryStatsRow: React.FC<SummaryStatsRowProps> = ({
  availableHeadcount,
  tunedHeadcount,
  totalHours,
  directHours,
  indirectHours,
  includedPathCount,
  excludedPathCount,
}) => {
  return (
    <Box type="fill" spacingInset="300">
      <Row spacing="500" wrap="down">
        <Column>
          <Text type="b100" color="secondary">AVAILABLE HC</Text>
          <Text type="d100">{availableHeadcount}</Text>
        </Column>
        <Column>
          <Tooltip position="top" title="Aggregated Headcount for the shift">
            <Text type="b100" color="secondary">TUNED HC</Text>
          </Tooltip>
          <Text type="d100">{tunedHeadcount}</Text>
        </Column>
        <Column>
          <Text type="b100" color="secondary">INCLUDED PATHS</Text>
          <Text type="d100">{includedPathCount}</Text>
        </Column>
        <Column>
          <Text type="b100" color="secondary">EXCLUDED PATHS</Text>
          <Text type="d100">{excludedPathCount}</Text>
        </Column>
        <Column>
          <Tooltip position="top" title="Total Hours for the shift">
            <Text type="b100" color="secondary">TOTAL HOURS</Text>
          </Tooltip>
          <Text type="d100">{totalHours}</Text>
        </Column>
        <Column>
          <Text type="b100" color="secondary">DIRECT HOURS</Text>
          <Text type="d100">{directHours}</Text>
        </Column>
        <Column>
          <Text type="b100" color="secondary">INDIRECT HOURS</Text>
          <Text type="d100">{indirectHours}</Text>
        </Column>
      </Row>
    </Box>
  );
};

export default SummaryStatsRow;
